/**
 * Per-page-load window identity for cross-window coordination (OR-22558).
 *
 * Deliberately a module-scope UUID and NOT `sessionStorage`: `window.open()`
 * copies the opener's `sessionStorage` into the child window, so a
 * sessionStorage-based id would be identical in both windows and defeat the
 * self-message filter in `subscribeCoord` (each window must ignore only its own
 * broadcasts). A fresh id per page load guarantees opener and viewer differ.
 * Ported from the `dsc-dual-window-poc` `src/store/tabIdentity.ts`.
 */
const tabId = crypto.randomUUID();

/**
 * The current window's coordination id.
 * @returns {string} A stable-per-page-load unique id.
 */
export function getTabId(): string {
  return tabId;
}
